import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL;

export const submitEnquiry = (payload) =>
  axios.post(`${API}/api/enquiries`, payload).then((r) => r.data);
